import moment from 'moment';

export const getPreviousReportActivityDate = (previousDate: string | null, activeDate: Date) => {
	const lastDate = previousDate ? moment(previousDate) : moment(activeDate);
	return lastDate.subtract(3, 'weeks').format('YYYY-MM-DD');
};

export const getNextReportActivityDate = (
	nextDate: string | null | undefined,
	activeDate?: Date,
) => {
	const lastDate = nextDate ? moment(nextDate) : moment(activeDate);
	return lastDate.add(3, 'weeks').format('YYYY-MM-DD');
};

export const isEmptyReportActivity = (
	activity: Record<string, { user_playlist_sections?: unknown[] }>,
) => {
	let userPlaylistSectionsCount = 0;
	for (const key in activity) {
		if (activity[key].user_playlist_sections?.length) {
			userPlaylistSectionsCount += activity[key].user_playlist_sections!.length;
		}
	}
	return userPlaylistSectionsCount < 5;
};

export const getHoursAndMinutes = (minutes: number) => {
	const hours = Math.floor(minutes / 60);
	const remainingMinutes = minutes % 60;

	return { hours, minutes: remainingMinutes };
};
